// Contenido de las guías rápidas del módulo Inventario.
// Editable aquí. Usa **palabra** para resaltar en negrita dentro de un texto.
// Cada sección: { titulo, intro, pasos: [{ titulo, texto, admin? }] }

export const AYUDA_INVENTARIO = {
  dashboard: {
    titulo: 'Dashboard de inventario',
    intro: 'Visión general: cuánto tienes, qué hay que vigilar y cuánto vale.',
    pasos: [
      { titulo: 'Lee los KPIs de un vistazo', texto: 'Arriba ves los totales: activos por estado, stock y el **valor del inventario**.' },
      { titulo: 'Vigila el stock', texto: 'El panel de stock resalta en color los tipos por debajo del **umbral mínimo**.' },
      { titulo: 'Atiende los vencimientos', texto: 'Las fechas que se acercan (ITV, caducidades…) aparecen ordenadas por **urgencia**.' },
      { titulo: 'Consulta el valor', texto: 'El KPI **Valor del inventario** suma el coste de los activos no dados de baja, con desglose **disponible** y **asignado**.' },
    ],
  },
  tipos: {
    titulo: 'Tipos de artículo',
    intro: 'Define qué gestionas y con qué datos. Cada tipo (coche, portátil, móvil…) tiene su propia estructura.',
    pasos: [
      { titulo: 'Crea categorías', texto: 'Agrupa los tipos por categoría (Equipos, Vehículos…) para ordenarlos en el menú.', admin: true },
      { titulo: 'Crea un tipo', texto: 'Indica nombre, **scope** (interno o colaboradores) e icono. La referencia se genera sola.', admin: true },
      { titulo: 'Define sus campos', texto: 'Añade los datos a guardar (matrícula, fecha de ITV, usuario asignado…). Cada campo tiene su tipo.', admin: true },
      { titulo: 'Activa stock o coste si aplica', texto: 'Marca **gestionado con stock** o **tiene coste** según el tipo; el coste sumará al valor del inventario.', admin: true },
    ],
  },
  compras: {
    titulo: 'Compras y alta de activos',
    intro: 'Registra las unidades reales que entran en el inventario.',
    pasos: [
      { titulo: 'Da de alta una unidad', texto: 'Crea el activo de su tipo y rellena sus datos (incluido el **coste**, si el tipo lo lleva).' },
      { titulo: 'Queda disponible', texto: 'Al darlo de alta, el activo queda **disponible** y listo para asignar a una persona.' },
    ],
  },
  historial: {
    titulo: 'Historial de movimientos',
    intro: 'Cada activo guarda su línea de tiempo: asignaciones, devoluciones, reparaciones y bajas.',
    pasos: [
      { titulo: 'Consulta los eventos', texto: 'Abre un activo para ver su **historial** completo, ordenado por fecha.' },
      { titulo: 'Corrige una fecha', texto: 'Si una fecha es errónea, edítala desde el historial indicando el **motivo** (queda auditado).', admin: true },
      { titulo: 'Trazabilidad de bajas', texto: 'Al dar de baja un activo se **desasigna solo**; el historial deja constancia de quién lo tenía.' },
    ],
  },
  ajustes: {
    titulo: 'Ajustes y alertas',
    intro: 'Configura los avisos para no quedarte sin stock ni pasar por alto una fecha clave.',
    pasos: [
      { titulo: 'Define umbrales de stock', texto: 'Marca el **mínimo por tipo** (y por empresa); por debajo salta el aviso de stock bajo.', admin: true },
      { titulo: 'Crea reglas de vencimiento', texto: 'Avisa con **X días de antelación** de fechas como la ITV o caducidades.', admin: true },
      { titulo: 'Elige el canal', texto: 'Los avisos llegan por **email** y/o en la **campana**, a quien tú decidas.', admin: true },
    ],
  },
};
